import React from 'react';
import { CheckCircle2Icon, SparklesIcon, BeakerIcon, PackageIcon, ScaleIcon } from 'lucide-react';
export function WhyShopSection() {
  const trustPoints = ['100% WA Owned & Operated since day one', 'Expert staff who actually own pets and gardens', 'Free drop-off within 5km on orders over $100', 'Open 7 days across all 6 Perth stores'];
  const services = [{
    title: 'DIY Dog Wash',
    description: 'Professional wash bays, no booking needed',
    icon: SparklesIcon
  }, {
    title: 'Pool Water Testing',
    description: 'Free testing with expert chemical advice',
    icon: BeakerIcon
  }, {
    title: 'Carry to Car',
    description: "Heavy bags? We'll carry them for you",
    icon: PackageIcon
  }, {
    title: 'Pet Weigh-ins',
    description: "Free weigh-ins to track your pet's health",
    icon: ScaleIcon
  }];
  return <section className="py-20 bg-white" data-id="element-375">
      <div className="container-wide" data-id="element-376">
        <div className="bg-brand-blue-900 rounded-[2.5rem] overflow-hidden shadow-elevated" data-id="element-377">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-378">
            {/* Image Side — Two stacked store photos */}
            <div className="relative flex flex-col" data-id="element-379">
              <div className="relative h-1/2 min-h-[250px] overflow-hidden" data-id="element-380">
                <img src="https://cdn.magicpatterns.com/uploads/gYcRdpPc38QZ66AgQ6wmdk/Not_just_another_faceless_online_store_malaga.png" alt="Better Pets and Gardens Malaga Store" className="w-full h-full object-cover object-top" data-id="element-381" />
                <div className="absolute inset-0 bg-brand-blue-900/10" data-id="element-382"></div>
                {/* WA Owned badge overlay */}
                <div className="absolute top-6 left-6 bg-white rounded-2xl p-3 shadow-elevated" data-id="element-383">
                  <img src="https://cdn.magicpatterns.com/uploads/cHcSSRvAwPTr86uE9Kk5yi/WA_OWned.webp" alt="Western Australian Owned" className="w-14 h-14 rounded-full object-cover" data-id="element-384" />
                </div>
              </div>
              <div className="relative h-1/2 min-h-[250px] overflow-hidden" data-id="element-385">
                <img src="https://cdn.magicpatterns.com/uploads/955MqdeHatH5mLbKcwtLuc/Not_just_another_faceless_online_store.png" alt="Better Pets and Gardens Store Front" className="w-full h-full object-cover object-center" data-id="element-386" />
                <div className="absolute inset-0 bg-brand-blue-900/10" data-id="element-387"></div>
              </div>
            </div>

            {/* Content Side */}
            <div className="p-10 md:p-14 flex flex-col justify-center" data-id="element-388">
              <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-white mb-6 leading-tight" data-id="element-389">
                Not just another
                <br data-id="element-390" />
                faceless online store.
              </h2>
              <p className="text-brand-blue-100 text-lg mb-8 leading-relaxed" data-id="element-391">
                We're your local experts dedicated to helping your pets thrive,
                your garden grow, and your pool sparkle.
              </p>

              <ul className="space-y-4 mb-10" data-id="element-392">
                {trustPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-393">
                    <CheckCircle2Icon className="w-5 h-5 text-brand-green-400 flex-shrink-0 mt-0.5" data-id="element-394" />
                    <span className="text-white font-medium" data-id="element-395">{point}</span>
                  </li>)}
              </ul>

              {/* In-Store Services Grid */}
              <div className="border-t border-brand-blue-800 pt-8 mb-8" data-id="element-396">
                <h3 className="font-heading font-bold text-white text-lg mb-5" data-id="element-397">
                  In-Store Services
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-398">
                  {services.map((service, index) => <div key={index} className="flex items-start gap-3" data-id="element-399">
                      <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0" data-id="element-400">
                        <service.icon className="w-4 h-4 text-brand-green-300" data-id="element-401" />
                      </div>
                      <div data-id="element-402">
                        <div className="text-white font-semibold text-sm" data-id="element-403">
                          {service.title}
                        </div>
                        <div className="text-brand-blue-200 text-xs" data-id="element-404">
                          {service.description}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              <button className="btn-green self-start shadow-soft" data-id="element-405">
                Find Your Nearest Store
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}